export default __webpack_public_path__ + "static/media/IMG_4610.e4c23ab4.jpeg";